export const supportSteps = [
  {
    element: '#contactsupport',
    popover: {
      title: 'Contact MoveAI Support ',
      showButtons: ['next', 'close'],
      description:
        '<div><ul><li> For assistance, email support@moveaihealth.com.</li> </ul></div>',
    },
  },
]
